package com.example.mystybag.appCore.model

import androidx.compose.ui.graphics.Color
import com.example.mystybag.core.expected.Preferences.getString
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_PHOTO_GUID
import com.example.mystybag.core.extensions.addDownloadLink
import com.example.mystybag.core.extensions.ifNotEmpty
import com.example.mystybag.core.model.IconDescription
import com.example.mystybag.core.model.ImageDescription
import com.example.mystybag.core.resources.SRC
import com.example.mystybag.core.ui.theme.LocalTheme.p36
import com.example.mystybag.core.views.ColorDefines
import com.example.mystybag.core.views.SharedColor
import com.example.mystybag.core.views.currentTheme

data class PersonalDetailsUIState(
    var userImage               : ImageDescription  = ImageDescription(
        link = getString(PREFERENCES_PHOTO_GUID, "").let { raw -> if (raw.startsWith("http")) raw else raw.ifNotEmpty { it.addDownloadLink() } },
        icon = IconDescription(
            resource    = SRC.images.avatar_fill_icon,
            imageSize   = p36,
            background  = SharedColor(color = ColorDefines.SurfaceContainerHighest)
        )
    ),
    var userName                : String            = "",
    var dialCode                : String            = "",
    var phoneNumber             : String            = "",
    var email                   : String            = "",
    var city                    : String            = "",
    var emailFieldColor         : Color             = currentTheme.value.colors.surfaceContainer,
    var emailTextColor          : Color?            = null
)